module.exports = __webpack_public_path__ + "img/waiting-6.1d2b9af4.png";